import React from 'react';
import styles from './style.module.scss';

const MonthGroup = ({ month, threads }) => {
  // Sort threads by date (newest first)
  const sortedThreads = [...threads].sort((a, b) => {
    const dateA = new Date(a.mainNote.created_at);
    const dateB = new Date(b.mainNote.created_at);
    return dateB - dateA;
  });

  return (
    <div className={styles.monthGroup}>
      <h4 className={styles.monthHeader}>{month}</h4>
      <div className={styles.threads}>
        {sortedThreads.map((thread, index) => (
          <div key={thread.mainNote.id || index} className={styles.thread}>
            {thread.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthGroup; 